import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import LocationIcon from "../../components/Icons/LocationIcon";
import ErrorMessage from "../../components/comman/ErrorMessage";
import MapComponent from "../../components/comman/MapComponent";
import UploadPlusIcon from "../../components/Icons/UploadPlusIcon";
import SearchSelectBox from "../../components/comman/SearchSelectBox";
import { MainFilterHandler } from "../../components/comman/MainFilterHandler";
import SupplyServiceBudget from "./SiteSettings/Budget/SupplyServiceBudget";
import StaffBudget from "./SiteSettings/Budget/StaffBudget";
import ViewDocumentModal from "./ViewDocumentModal";
import SearchSelectInput from "../../components/comman/SearchSelectInput";
import { errorTypes } from "../../utility/InputValidation";
import moment from "moment";
import calculateFinancialYears, { indianStates } from "../../utility/CommonFunctions";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";
import RequestSelectorModal from "./SiteSettings/Budget/RequestSelectorModal";
import { RoutesLink } from "../../ApiHelper/RoutesLink";

export default function AddSite() {
  const navigate = useNavigate();
  const location = useLocation();
  const [budgetLoading, setBudgetLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    activeSubTab: 1,
    customerList: [],
    companyList: [],
    customerCompanyList: [],
    departmentList: [],
    expenseHeadList: [],
    designationList: [],
    isLoading: false,
    customerListLoader: false,
    Id_onCreateSite: "",
    fileError: "",
    customerId: "",
    type: "Supply",
    EditData: null,
    companyId: "",
    companyName: "",
    companyListLoading: false,
    financialYears: (() => {
      const data = location?.state?.data;
      const startDate = data?.site?.startDate || data?.startDate;
      const endDate = data?.site?.endDate || data?.endDate;
      if (!startDate || !endDate) {
        const now = moment();
        const month = now.month() + 1;
        const year = now.year();
        const fyStartYear = month >= 4 ? year : year - 1;
        return [`${fyStartYear}-${fyStartYear + 1}`];
      }
      return calculateFinancialYears(
        moment.utc(startDate).format("YYYY-MM-DD"),
        moment.utc(endDate).format("YYYY-MM-DD")
      );
    })(),
    activeFinancialYear: (() => {
      const data = location?.state?.data;
      const startDate = data?.site?.startDate || data?.startDate;
      const endDate = data?.site?.endDate || data?.endDate;

      const now = moment();
      const month = now.month() + 1;
      const year = now.year();
      const fyStartYear = month >= 4 ? year : year - 1;
      const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

      if (!startDate || !endDate) return currentFY;

      const fys = calculateFinancialYears(
        moment.utc(startDate).format("YYYY-MM-DD"),
        moment.utc(endDate).format("YYYY-MM-DD")
      );

      return fys.includes(currentFY) ? currentFY : fys[0] || "";
    })(),
    siteDetail: null,
    loadingSiteDetail: false,
  });
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const [preUploadedDocs, setPreUploadedDocs] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const apiKey = import.meta.env.VITE_APP_API_KEY;
  const [mapCenter, setMapCenter] = useState({ lat: 28.0229, lng: 73.3119 });
  const [markers, setMarkers] = useState([{ lat: 28.0229, lng: 73.3119 }]);
  const [circleRadius, setCircleRadius] = useState(0);
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [requestModal, setRequestModal] = useState(false);
  const toggleRequestModal = () => {
    setRequestModal(!requestModal);
  };

  const handleCreateNew = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request, {
      state: {
        type: "create",
        siteId: location?.state?.data?.site?.id || location?.state?.data?.id,
        siteName: location?.state?.data?.site?.name || location?.state?.data?.name,
        site: location?.state?.data?.site || location?.state?.data,
        isDisabled: true,
        financialYear: pageStates?.activeFinancialYear
      }
    });
  };

  const handleEditExisting = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request, {
      state: {
        type: "edit",
        siteId: location?.state?.data?.site?.id || location?.state?.data?.id,
        siteName: location?.state?.data?.site?.name || location?.state?.data?.name,
        isDisabled: true,
        financialYear: pageStates?.activeFinancialYear
      }
    });
  };

  const handleDeleteExisting = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request, {
      state: {
        type: "edit",
        siteId: location?.state?.data?.site?.id || location?.state?.data?.id,
        siteName: location?.state?.data?.site?.name || location?.state?.data?.name,
        isDisabled: true,
        isDelete: true
      }
    });
  };


  const {
    register: registerFirst,
    handleSubmit: handleSubmitFirst,
    reset: resetFirst,
    watch: watchFirst,
    setValue: setValueFirst,
    formState: { errors: errorsFirst },
    control: controlFirst,
  } = useForm();


  const {
    register: registerSecond,
    handleSubmit: handleSubmitSecond,
    reset: resetSecond,
    watch: watchSecond,
    setValue: setValueSecond,
    getValues: getValueSecond,
    formState: { errors: errorsSecond },
  } = useForm();

  const GetSiteBudget = (type) => {
    setBudgetLoading(true);
    const url =
      apiUrl.get_site_budget +
      `type=${type}&siteId=${location?.state?.data?.site?.id ||
      location?.state?.data?.id ||
      pageStates?.Id_onCreateSite
      }&financialYear=${pageStates?.activeFinancialYear}`;
    callApi(url, { method: "GET" }).then((res) => {
      setBudgetLoading(false);
      if (res?.status) {
        setPageStates((pre) => ({
          ...pre,
          EditData: res?.data?.length > 0 ? res?.data : null,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    if (location?.state?.data || pageStates?.Id_onCreateSite) {
      setPageStates((prev) => ({
        ...prev,
        activeTab: tab,
      }));
      if (tab === 3) {
        toggleSubTab(4, "supplyBudget");
      }
    } else {
      toast.error("Please Create Site First!");
    }
  };
  const toggleSubTab = (tab, type = null) => {
    setPageStates((prev) => ({
      ...prev,
      activeSubTab: tab,
      ...(tab !== 6 && {
        type: tab == 4 ? "Supply" : tab === 7 ? "General" : "Service",
      }),
      EditData: null,
    }));
    if (tab == 6) {
      // printData(tab, type)
      getDepartMent();
    }
    if ((location?.state?.data || pageStates?.Id_onCreateSite) && type) {
      GetSiteBudget(type);
    }
  };

  useEffect(() => {
    if (pageStates?.activeSubTab === 4) {
      GetSiteBudget("supplyBudget");
    } else if (pageStates?.activeSubTab === 5) {
      GetSiteBudget("serviceBudget");
    } else if (pageStates?.activeSubTab === 6) {
      GetSiteBudget("staffBudget");
    } else if (pageStates?.activeSubTab === 7) {
      GetSiteBudget("generalBudget");
    }
  }, [pageStates?.activeFinancialYear]);

  const getDepartMent = () => {
    setPageStates((pre) => ({ ...pre, expenseHeadLoader: true }));
    const url = apiUrl.get_department + "?type=site";
    callApi(url, { method: "GET" }).then((res) => {
      setPageStates((pre) => ({ ...pre, expenseHeadLoader: false }));
      if (res?.status) {
        setPageStates((pre) => ({
          ...pre,
          departmentList: res?.data?.department,
        }));
      }
    });
  };

  useEffect(() => {
    if (location?.state?.data) {
      GetSiteDetail(location?.state?.data?.site?.id || location?.state?.data?.id);
    }
    GetCompanyList();
  }, []);

  useEffect(() => {
    GetExpenseHeadOrDesignationList(null);
  }, [pageStates?.type]);

  const GetSiteDetail = (id) => {
    let options = {
      method: "GET",
    };
    setPageStates((prev) => ({
      ...prev,
      loadingSiteDetail: true,
    }));
    let API = apiUrl.get_site + `?siteId=${id}`;
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingSiteDetail: false,
      }));
      if (response?.status === true) {
        const site = response?.data?.site?.[0] || {};

        if (site?.customer?.id) {
          GetCustomerCompanyList(site?.customer?.id);
        }

        setTimeout(() => {
          setValueFirst("customerCompanyId", site?.customerCompanyId);
        }, 1000);

        resetFirst({
          name: site?.name,
          companyId: site?.Company?.id,
          startDate: site?.startDate ? moment(site?.startDate).format("YYYY-MM-DD") : "",
          endDate: site?.endDate ? moment(site?.endDate).format("YYYY-MM-DD") : "",
          gst: site?.customercompany?.gst,
          address: site?.customercompany?.address,
          salaryCycleStartDay: site?.salaryCycleStartDay,
          Mw: site?.Mw,
          state: site?.state,
        });

        setPageStates((prev) => ({
          ...prev,
          companyName: site?.Company?.name,
          customerId: site?.customer?.id,
          selectedFile: site?.document
        }));

        setPreUploadedDocs(site?.documents || []);


        const locationData = typeof site?.location === "string" ? JSON.parse(site?.location) : site?.location;
        const latitude = parseFloat(locationData?.lat);
        const longitude = parseFloat(locationData?.lng);
        const range = parseFloat(site?.range);

        setMapCenter({ lat: latitude, lng: longitude });
        setMarkers([{ lat: latitude, lng: longitude }]);
        setCircleRadius(range);

        resetSecond({
          searchedLocation: site?.searchedLocation,
          address: site?.address,
          range: site?.range || 0,
          lat: latitude,
          lng: longitude,
        });

        const startDate = site?.startDate;
        const endDate = site?.endDate;
        const now = moment();
        const month = now.month() + 1;
        const year = now.year();
        const fyStartYear = month >= 4 ? year : year - 1;
        const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

        if (!startDate || !endDate) {
          setPageStates((prevStates) => ({
            ...prevStates,
            siteDetail: site,
            financialYears: [currentFY],
            activeFinancialYear: currentFY,
          }));
          return;
        }

        const fys = calculateFinancialYears(
          moment.utc(startDate).format("YYYY-MM-DD"),
          moment.utc(endDate).format("YYYY-MM-DD")
        );

        const defaultFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

        setPageStates((prevStates) => ({
          ...prevStates,
          siteDetail: site,
          financialYears: fys,
          activeFinancialYear: defaultFY || currentFY,
        }));
      }
    });
  };

  const GetExpenseHeadOrDesignationList = (type = null) => {
    setPageStates((prev) => ({ ...prev, expenseHeadLoader: true }));
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_expense_head + "?" + MainFilterHandler(pageStates);
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({ ...prev, expenseHeadLoader: false }));
      if (response?.status === true) {
        setPageStates((prevStates) => ({
          ...prevStates,
          expenseHeadList: response?.data?.expenseHead,
        }));
      }
    });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_company;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prevStates) => ({
          ...prevStates,
          companyList: response?.data?.company?.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          })),
        }));
      }
    });
  };
  const GetCustomerCompanyList = (customerId) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_customer_company + `?customerId=${customerId}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prevStates) => ({
          ...prevStates,
          customerCompanyList: response?.data?.customerCompany,
        }));
        if (location?.state?.data) {
          const findCustomer = response?.data?.customerCompany?.find(
            (item) =>
              item?.id === location?.state?.data?.site?.customerCompanyId ||
              item?.id === location?.state?.data?.customerCompanyId
          );
          setValueFirst("gst", findCustomer?.gst);
          setValueFirst("address", findCustomer?.address);
        }
      }
    });
  };

  const fetchCustomers = (inputValue) => {
    return new Promise((resolve) => {
      let API = inputValue
        ? `${apiUrl.get_customer}?search=${inputValue}`
        : `${apiUrl.get_customer}`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        customerListLoader: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            setPageStates((prev) => ({
              ...prev,
              customerListLoader: false,
              customerList: response?.data?.customer.map((customer) => ({
                value: customer.id,
                label: customer.name,
              })),
            }));
            resolve(
              response?.data?.customer.map((customer) => ({
                value: customer.id,
                label: customer.name,
              }))
            );
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const handleSearchChange = (data) => {
    setPageStates((prev) => ({
      ...prev,
      customerId: data?.value,
    }));
    GetCustomerCompanyList(data?.value);
    setValueFirst("gst", "");
    setValueFirst("address", "");
    if (data) {
      setError("");
    } else {
      setError("This field is Required");
    }
  };

  const FirstFormSubmit = (data) => {

    if (!pageStates?.customerId) {
      setError("This field is Required");
      return;
    }

    // if (uploadedFiles?.length == 0 && preUploadedDocs?.length == 0) {
    //   toast.error("Please Select Document");
    //   return;
    // }

    const formData = new FormData();
    formData.append("name", data?.name);
    formData.append("customerId", pageStates?.customerId);
    formData.append("companyId", data?.companyId);
    formData.append("startDate", data?.startDate);
    formData.append("endDate", data?.endDate);
    formData.append("customerCompanyId", data?.customerCompanyId);
    formData.append("salaryCycleStartDay", data?.salaryCycleStartDay);
    formData.append("Mw", data?.Mw || "");
    formData.append("state", data?.state || "");

    uploadedFiles?.forEach((file, index) => {
      formData.append(`documents[${index}]`, file);
    });

    if (!location?.state?.data) {
      formData.append("type", location?.state?.type);
    }

    const options = {
      method: "POST",
      form_data: formData,
    };

    const isEdit = Boolean(location?.state?.data);

    const API = isEdit
      ? `${apiUrl?.update_site}?siteId=${location?.state?.data?.site?.id || location?.state?.data?.id
      }`
      : apiUrl?.add_site;

    setPageStates((prev) => ({ ...prev, isLoading: true }));

    callApi(API, options).then((response) => {
      setPageStates((prev) => ({ ...prev, isLoading: false }));

      if (response?.status) {
        toast.success(response?.message);

        setPageStates((prev) => ({
          ...prev,
          activeTab: 2,
          ...(isEdit ? {} : { Id_onCreateSite: response?.data?.id }),
        }));

        const fys = calculateFinancialYears(data?.startDate, data?.endDate);
        const getCurrentFYLabel = () => {
          const now = moment();
          const month = now.month() + 1;
          const year = now.year();
          const fyStartYear = month >= 4 ? year : year - 1;
          return `${fyStartYear}-${fyStartYear + 1}`;
        };

        const currentFY = getCurrentFYLabel();
        const defaultFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

        setPageStates((prev) => ({
          ...prev,
          financialYears: fys,
          activeFinancialYear: defaultFY || currentFY,
        }));

      } else {
        toast.error(response?.message);
      }
    });
  };

  const secondFormSubmit = (data) => {
    // console.log("secondFormData>>>>>>>>>", data);
    const cords = {
      lat: data?.lat,
      lng: data?.lng,
    };
    let formData = new FormData();
    formData.append("searchedLocation", data?.searchedLocation);
    formData.append("address", data?.address);
    formData.append("location", JSON.stringify(cords));
    formData.append("range", data?.range);

    const options = {
      method: "POST",
      form_data: formData,
    };
    let siteId =
      location?.state?.data?.site?.id || location?.state?.data?.id
        ? location?.state?.data?.site?.id || location?.state?.data?.id
        : pageStates?.Id_onCreateSite;
    let API = apiUrl?.update_site + `?siteId=${siteId}`;
    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStates((prev) => ({
          ...prev,
          activeTab: 3,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const ThirdFormSubmit = (data, type) => {
    // Map human-readable type to backend-expected camelCase type
    let apiType = type;
    if (type === "Supply Budget") apiType = "supplyBudget";
    else if (type === "Service Budget") apiType = "serviceBudget";
    else if (type === "Staff Budget") apiType = "staffBudget";
    else if (type === "General Expense Head" || type === "General Budget") apiType = "generalBudget";

    let siteId =
      location?.state?.data?.site?.id || location?.state?.data?.id
        ? location?.state?.data?.site?.id || location?.state?.data?.id
        : pageStates?.Id_onCreateSite;

    let siteBudget = { siteBudget: data, type: apiType, siteId: siteId, financialYear: pageStates?.activeFinancialYear };

    const options = {
      method: "POST",
      data: siteBudget,
    };
    let API = apiUrl?.add_site_budget;
    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        GetSiteBudget(apiType);
        // navigate(-1);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleFilesChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to Array
    const MAX_SIZE_MB = 6; // Maximum file size limit in MB
    const newFiles = [];
    let error = "";

    files.forEach((file) => {
      if (file.size / 1024 / 1024 > MAX_SIZE_MB) {
        error = `File "${file.name}" exceeds the size limit of 6MB.`;
        toast.error(error);
      } else {
        newFiles.push(file);
      }
    });

    setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setPageStates((prevState) => ({
      ...prevState,
      fileError: error,
    }));

    event.target.value = "";
  };

  const removeFile = (index) => {
    setUploadedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  const handleDeleteDocument = (docId) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_document + `?documentId=${docId}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPreUploadedDocs((prevDocs) =>
          prevDocs.filter((doc) => doc.id !== docId)
        );
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const getCoordinates = () => {
    const searchedLocation = getValueSecond("searchedLocation");

    if (!searchedLocation) {
      toast.error("Please enter an address or embed code.");
      return;
    }

    setIsLoadingAddress(true);

    const coordinates = extractLatLngFromIframe(searchedLocation);
    if (coordinates) {
      const { lat, lng } = coordinates;

      setValueSecond("lat", lat);
      setValueSecond("lng", lng);
      setMapCenter({ lat, lng });
      setMarkers([{ lat, lng }]);
      toast.success("Coordinates extracted from embed code!");
      setIsLoadingAddress(false);
      return;
    }

    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      searchedLocation
    )}&key=${apiKey}`;

    fetch(geocodeUrl)
      .then((res) => res.json())
      .then((data) => {
        setIsLoadingAddress(false);
        if (data?.status === "OK" && data?.results?.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          setValueSecond("lat", lat);
          setValueSecond("lng", lng);
          setMapCenter({ lat, lng });
          setMarkers([{ lat, lng }]);
          toast.success("Coordinates fetched successfully!");
        } else {
          toast.error("Unable to find coordinates for the entered address.");
        }
      })
      .catch(() => {
        toast.error("Error fetching coordinates. Please try again.");
      });
  };

  const extractLatLngFromIframe = (input) => {
    try {
      // Extract src="..." from iframe HTML
      const srcMatch = input.match(/src="([^"]+)"/);
      const srcUrl = srcMatch ? decodeURIComponent(srcMatch[1]) : input;

      // Extract both !3dLAT and !2dLNG (order matters)
      const latMatch = srcUrl.match(/!3d([0-9.-]+)/);
      const lngMatch = srcUrl.match(/!2d([0-9.-]+)/);

      if (latMatch && lngMatch) {
        return {
          lat: parseFloat(latMatch[1]),
          lng: parseFloat(lngMatch[1]),
        };
      }

      return null;
    } catch (err) {
      return null;
    }
  };

  const handleSearchEmp = async (data = null) => {
    setPageStates((pre) => ({ ...pre, companyListLoading: true }));
    let API = `${apiUrl.get_company}?search=${data}`;

    const response = await callApi(API);
    if (response?.status) {
      setPageStates((pre) => ({
        ...pre,
        companyList: response?.data?.company?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        })),
        companyListLoading: false,
        ...(pre.companyId ? { companyId: "" } : {}),
      }));
      setValueFirst("companyName", "");
    }
    return response;
  };

  return (
    <>
      {(pageStates?.loadingSiteDetail || pageStates?.expenseHeadLoader) && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Add"} Site
            </h1>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="wizard-tabs d-flex align-items-center justify-content-between">
              <Nav tabs className="nav nav-pills">
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      pageStates?.activeTab === 1 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(1)}
                  >
                    <h6>Step 1</h6>
                    <h5>Site Details</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      pageStates?.activeTab === 2 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(2)}
                  >
                    <h6>Step 2</h6>
                    <h5>Site Location</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      pageStates?.activeTab === 3 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(3)}
                  >
                    <h6>Step 3</h6>
                    <h5>Site Budget</h5>
                  </NavLink>
                </NavItem>
              </Nav>
              {pageStates?.activeTab === 3 && (
                <div className="mb-3 d-flex justify-content-end">
                  <select
                    style={{ width: "200px" }}
                    className="form-select fw-semibold"
                    value={pageStates?.activeFinancialYear}
                    onChange={(e) =>
                      setPageStates({ ...pageStates, activeFinancialYear: e.target.value })
                    }
                  >
                    {pageStates?.financialYears?.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

          </div>
        </div>

        <TabContent activeTab={pageStates?.activeTab}>
          <TabPane tabId={1}>
            <Fade in={pageStates?.activeTab === 1} timeout={200}>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmitFirst(FirstFormSubmit)}>
                    <div className="row">
                      <div className="col-12">
                        <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                          Normal Details
                        </h4>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="firstName" className="form-label">
                            Site Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Site Name"
                            id="firstName"
                            aria-describedby="emailHelp"
                            {...registerFirst("name", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errorsFirst?.name?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3 position-relative">
                          <label
                            htmlFor="customerSearch"
                            className="form-label"
                          >
                            Customer
                            <span className="text-danger">*</span>
                          </label>

                          {/* Search Input */}
                          <SearchSelectBox
                            value={pageStates?.customerId}
                            onChange={handleSearchChange}
                            fetchOptions={fetchCustomers}
                            loading={pageStates.customerListLoader}
                            isAsync={true}
                            defaultFetch={true} // Fetch all customers on first load
                            title="Search for a Customer"
                            error={error}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="form-group mb-3">
                          <Controller
                            name="companyId"
                            control={controlFirst}
                            rules={{ ...errorTypes.required("Company") }}
                            render={({ field, fieldState }) => (
                              <SearchSelectInput
                                label="Company"
                                placeholder="Search Company"
                                value={pageStates?.companyName}
                                onSelect={(option) => {
                                  field.onChange(option?.value);
                                  setPageStates((pre) => ({
                                    ...pre,
                                    companyId: option?.value,
                                    companyName: option?.label,
                                  }));
                                }}
                                onBlur={field.onBlur}
                                errors={fieldState.error?.message}
                                options={pageStates?.companyList}
                                onSearch={handleSearchEmp}
                                isLoading={pageStates?.companyListLoading}
                                showAddButton={false}
                                required={true}
                                disabled={pageStates?.companyList?.length === 0}
                              />
                            )}
                          />
                        </div>
                      </div>

                      {/* Start Date */}
                      <div className="col-12 col-md-4 mb-3">
                        <label className="form-label mb-1">
                          Start Date <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="startDate"
                          control={controlFirst}
                          rules={{
                            required: "Please select start date",
                            validate: (value) => {
                              if (!value) return true;
                              // No future check here as sites can start in future
                              return true;
                            }
                          }}
                          render={({ field }) => (
                            <DatePicker size="sm"
                              {...field}
                              id="startDate"
                              format="dd/MM/yyyy"
                              oneTap
                              placeholder="dd/mm/yyyy"
                              style={{ width: "100%" }}
                              value={field.value ? new Date(field.value) : null}
                              onChange={(date) => {
                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                              }}
                              cleanable={false}
                            />
                          )}
                        />
                        <ErrorMessage message={errorsFirst?.startDate?.message} />
                      </div>

                      {/* End Date */}
                      <div className="col-12 col-md-4 mb-3">
                        <label className="form-label mb-1">
                          End Date <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="endDate"
                          control={controlFirst}
                          rules={{
                            required: "Please select end date",
                            validate: (value) => {
                              const start = watchFirst("startDate");
                              if (start && moment(value).isBefore(moment(start))) {
                                return "End date cannot be before start date";
                              }
                              return true;
                            }
                          }}
                          render={({ field }) => (
                            <DatePicker size="sm"
                              {...field}
                              id="endDate"
                              format="dd/MM/yyyy"
                              oneTap
                              placeholder="dd/mm/yyyy"
                              style={{ width: "100%" }}
                              value={field.value ? new Date(field.value) : null}
                              onChange={(date) => {
                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                              }}
                              shouldDisableDate={(date) =>
                                watchFirst("startDate") &&
                                date < new Date(moment(watchFirst("startDate")).startOf('day'))
                              }
                              cleanable={false}
                            />
                          )}
                        />
                        <ErrorMessage message={errorsFirst?.endDate?.message} />
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="salaryCycleStartDay" className="form-label">
                            Salary Cycle Start Date
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select form-control"
                            id="salaryCycleStartDay"
                            {...registerFirst("salaryCycleStartDay", {
                              required: "This field is Required",
                            })}
                          >
                            <option value="">Select Salary Cycle Start Date</option>
                            <option value="1">1</option>
                            <option value="21">21</option>
                          </select>
                          <ErrorMessage message={errorsFirst?.salaryCycleStartDay?.message} />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="Mw" className="form-label">
                            Mw
                          </label>
                          <input
                            type="number"
                            step="any"
                            className="form-control"
                            placeholder="Mw"
                            id="Mw"
                            {...registerFirst("Mw")}
                            onWheel={(e) => e.target.blur()}
                          />
                          <ErrorMessage message={errorsFirst?.Mw?.message} />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="state" className="form-label">
                            State
                          </label>
                          <select
                            className="form-select form-control"
                            id="state"
                            {...registerFirst("state")}
                          >
                            <option value="">Select State</option>
                            {indianStates?.map((state) => (
                              <option key={state} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage message={errorsFirst?.state?.message} />
                        </div>
                      </div>

                      <div className="col-12">
                        <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                          Billing Details
                        </h4>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="form-group mb-3">
                          <label className="form-label">
                            Customers Company
                          </label>
                          <span className="text-danger">*</span>
                          <select
                            className="form-select form-control"
                            {...registerFirst("customerCompanyId", {
                              required: "Please select a company",
                            })}
                            onChange={(e) => {
                              const findCustomer =
                                pageStates?.customerCompanyList?.find(
                                  (item) => item?.id === e.target.value
                                );
                              setValueFirst("gst", findCustomer?.gst);
                              setValueFirst("address", findCustomer?.address);
                            }}
                          >
                            <option value="" className="d-none">
                              Select Company
                            </option>
                            {pageStates?.customerCompanyList?.length > 0 ? (
                              pageStates?.customerCompanyList?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.companyName}
                                </option>
                              ))
                            ) : (
                              <option disabled value="">
                                No Data Found
                              </option>
                            )}
                          </select>
                          <ErrorMessage
                            message={errorsFirst?.customerCompanyId?.message}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="firstName" className="form-label">
                            GST
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="GST"
                            id="firstName"
                            aria-describedby="emailHelp"
                            disabled
                            {...registerFirst("gst", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errorsFirst?.gst?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="firstName" className="form-label">
                            Address
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            id="firstName"
                            aria-describedby="emailHelp"
                            disabled
                            {...registerFirst("address", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage
                            message={errorsFirst?.address?.message}
                          />
                        </div>
                      </div>

                      <div className="col-8 mt-3">
                        <label htmlFor="documentUpload" className="form-label">
                          Upload Documents
                        </label>
                        <div className="img-uploader">
                          <input
                            type="file"
                            className="form-control d-none"
                            id="documentUpload"
                            accept="image/*,.pdf"
                            multiple
                            onChange={handleFilesChange}
                            ref={fileInputRef}
                          />

                          {/* Upload Button */}
                          <label
                            htmlFor="documentUpload"
                            className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                            style={{
                              display: "inline-block",
                              cursor: "pointer",
                              padding: "5px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              minWidth: "150px",
                            }}
                          >
                            <span className="placeholder-img">
                              <UploadPlusIcon />
                            </span>
                          </label>

                          <div className="file-preview mt-3">
                            {/* Pre-Uploaded Files */}
                            {preUploadedDocs?.map((doc) => (
                              <div
                                key={doc.id}
                                className="d-flex align-items-center justify-content-between mb-2"
                                style={{
                                  padding: "5px",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center w-100"
                                  onClick={() => {
                                    setSelectedDocument(doc);
                                    toggleModal();
                                  }}
                                >
                                  <div className="file-icon me-3">
                                    {doc?.url?.endsWith(".jpg") ||
                                      doc?.url?.endsWith(".png") ? (
                                      <img
                                        src={doc?.url}
                                        alt="Uploaded"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "4px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    ) : (
                                      <span role="img" aria-label="document">
                                        📄
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    <strong>
                                      {doc?.url?.split("-").pop()}
                                    </strong>
                                  </div>
                                </div>
                                <button
                                  className="btn btn-close bg-danger btn-sm ms-3"
                                  type="button"
                                  onClick={() => handleDeleteDocument(doc?.id)}
                                >
                                  ✖
                                </button>
                              </div>
                            ))}

                            {/* New Uploaded Files */}
                            {uploadedFiles?.map((file, index) => (
                              <div
                                key={index}
                                className="d-flex align-items-center justify-content-between mb-2 cursor-pointer"
                                style={{
                                  padding: "5px",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center w-100"
                                  onClick={() => {
                                    setSelectedDocument(file);
                                    toggleModal();
                                  }}
                                >
                                  <div className="file-icon me-3">
                                    {file?.type?.startsWith("image/") ? (
                                      <img
                                        src={URL.createObjectURL(file)}
                                        alt={file.name}
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "4px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    ) : (
                                      <span role="img" aria-label="document">
                                        📄
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    <strong>{file?.name}</strong>
                                  </div>
                                </div>
                                <button
                                  className="btn btn-close bg-danger btn-sm ms-3"
                                  type="button"
                                  onClick={() => removeFile(index)}
                                >
                                  ✖
                                </button>
                              </div>
                            ))}
                          </div>

                          {/* Validation Error */}
                          {pageStates?.fileError && (
                            <div className="text-danger mt-2">
                              {pageStates?.fileError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                      <button
                        className="btn btn-secondary px-4"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary px-4" type="submit">
                        {pageStates?.isLoading ? (
                          <Spinner />
                        ) : location?.state?.data ? (
                          "Update"
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={2}>
            <Fade in={pageStates?.activeTab === 2} timeout={200}>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmitSecond(secondFormSubmit)}>
                    <div className="row align-items-center row-gap-3">
                      <div className="col-12 mb-4">
                        <h4>Site Location</h4>
                        <MapComponent
                          apiKey={apiKey}
                          center={mapCenter}
                          markers={markers}
                          circleRadius={circleRadius || 0}
                          onMarkerDragEnd={(position) => {
                            // Update the form values and map state with new position
                            setValueSecond("lat", position.lat);
                            setValueSecond("lng", position.lng);
                            setMapCenter({
                              lat: position.lat,
                              lng: position.lng,
                            });
                            setMarkers([
                              { lat: position.lat, lng: position.lng },
                            ]);
                          }}
                        />
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-6">
                            <div className="form-group mb-3">
                              <label htmlFor="shiftTime" className="form-label">
                                Location <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="description"
                                placeholder="Search by address / Embed a map"
                                rows={3}
                                defaultValue={""}
                                {...registerSecond("searchedLocation", {
                                  required: "This field is Required",
                                })}
                              />
                              <ErrorMessage
                                message={
                                  errorsSecond?.searchedLocation?.message
                                }
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-3 d-flex align-items-center  justify-content-center mt-3">
                            <button
                              className="btn btn-primary w-auto"
                              type="button"
                              onClick={getCoordinates}
                            >
                              <LocationIcon />{" "}
                              {isLoadingAddress ? (
                                <Spinner />
                              ) : (
                                "Get Coordinates"
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-6">
                            <div className="form-group mb-3">
                              <label htmlFor="shiftTime" className="form-label">
                                Address <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="description"
                                rows={3}
                                defaultValue={""}
                                {...registerSecond("address", {
                                  required: "This field is Required",
                                })}
                              />
                              <ErrorMessage
                                message={errorsSecond?.address?.message}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="form-group mb-3">
                              <label htmlFor="lat" className="form-label">
                                Latitude
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                id="lat"
                                disabled
                                value={
                                  watchSecond("lat")
                                    ? Number(watchSecond("lat")).toFixed(4)
                                    : ""
                                }
                                {...registerSecond("lat", {
                                  required: "This field is Required",
                                  setValueAs: (value) =>
                                    Number(value).toFixed(4),
                                })}
                              />
                              <ErrorMessage
                                message={errorsSecond?.lat?.message}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="form-group mb-3">
                              <label htmlFor="lng" className="form-label">
                                Longitude
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                id="lng"
                                disabled
                                value={
                                  watchSecond("lng")
                                    ? Number(watchSecond("lng")).toFixed(4)
                                    : ""
                                }
                                {...registerSecond("lng", {
                                  required: "This field is Required",
                                  setValueAs: (value) =>
                                    Number(value).toFixed(4), // Ensure saved value is fixed to 4 decimals
                                })}
                              />
                              <ErrorMessage
                                message={errorsSecond?.lng?.message}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="form-group mb-3">
                              <label htmlFor="range" className="form-label">
                                Range (in mtr){" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                className="form-control"
                                id="range"
                                {...registerSecond("range", {
                                  required: "This field is Required",
                                  valueAsNumber: true,
                                })}
                                onChange={(e) => {
                                  const newRange = Number(e.target.value);
                                  setCircleRadius(newRange);
                                }}
                              />
                              <ErrorMessage
                                message={errorsSecond?.range?.message}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-4 mt-4">
                      <button
                        className="btn btn-secondary px-4"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary px-4" type="submit">
                        {pageStates?.isLoading ? <Spinner /> : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={3}>
            <Fade in={pageStates?.activeTab === 3} timeout={200}>
              <div className="row gap-2">
                <div className="col-12 d-flex align-items-center justify-content-between mb-3">
                  <Nav tabs className="nav nav-tabs border-0">
                    <NavItem className="nav-item">
                      <NavLink
                        className={
                          pageStates?.activeSubTab === 4
                            ? "btn btn-outline-primary px-5 rounded-0 rounded-start-1 border-end-0 border-start-1 active"
                            : "btn btn-outline-primary px-5 rounded-0 rounded-start-1 border-end-0 border-start-1"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab(4, "supplyBudget")}
                      >
                        Supply Budget
                      </NavLink>
                    </NavItem>
                    <li className="nav-item">
                      <div className="border-top-item" />
                    </li>
                    <NavItem className="nav-item">
                      <NavLink
                        className={
                          pageStates?.activeSubTab === 5
                            ? "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0 active"
                            : "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab(5, "serviceBudget")}
                      >
                        Service Budget
                      </NavLink>
                    </NavItem>
                    <li className="nav-item">
                      <div className="border-top-item" />
                    </li>
                    <NavItem className="nav-item">
                      <NavLink
                        className={
                          pageStates?.activeSubTab === 6
                            ? "btn btn-outline-primary px-5 rounded-0 rounded-0 border-end-0 border-start-0 active"
                            : "btn btn-outline-primary px-5 rounded-0 rounded-0 border-end-0 border-start-0"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab(6, "staffBudget")}
                      >
                        Staff Budget
                      </NavLink>
                    </NavItem>
                    <NavItem className="nav-item">
                      <NavLink
                        className={
                          pageStates?.activeSubTab === 7
                            ? "btn btn-outline-primary px-5 rounded-0 rounded-end-1 border-end-1 border-start-0 active"
                            : "btn btn-outline-primary px-5 rounded-0 rounded-end-1 border-end-1 border-start-0"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab(7, "generalBudget")}
                      >
                        General Budget
                      </NavLink>
                    </NavItem>
                  </Nav>
                  {pageStates?.EditData && <button
                    className="btn btn-outline-primary"
                    onClick={toggleRequestModal}
                  > Create Budget Request</button>}
                </div>
                <TabContent activeTab={pageStates?.activeSubTab}>
                  <TabPane tabId={4}>
                    <Fade in={pageStates?.activeSubTab === 4} timeout={200}>
                      <div className="col-12">
                        {pageStates?.activeSubTab === 4 && (
                          <SupplyServiceBudget
                            pageStates={pageStates}
                            type={"Supply Budget"}
                            ThirdFormSubmit={ThirdFormSubmit}
                            EditData={pageStates?.EditData}
                            GetSiteBudgets={GetSiteBudget}
                            isLoading={pageStates.isLoading}
                            budgetLoading={budgetLoading}
                            setBudgetLoading={setBudgetLoading}
                          />
                        )}
                      </div>
                    </Fade>
                  </TabPane>
                  <TabPane tabId={5}>
                    <Fade in={pageStates?.activeSubTab === 5} timeout={500}>
                      <div className="col-12">
                        {pageStates?.activeSubTab === 5 && (
                          <SupplyServiceBudget
                            pageStates={pageStates}
                            type={"Service Budget"}
                            ThirdFormSubmit={ThirdFormSubmit}
                            EditData={pageStates?.EditData}
                            GetSiteBudgets={GetSiteBudget}
                            isLoading={pageStates.isLoading}
                            budgetLoading={budgetLoading}
                            setBudgetLoading={setBudgetLoading}
                          />
                        )}
                      </div>
                    </Fade>
                  </TabPane>
                  <TabPane tabId={6}>
                    <Fade in={pageStates?.activeSubTab === 6} timeout={500}>
                      <div className="col-12">
                        <StaffBudget
                          ThirdFormSubmit={ThirdFormSubmit}
                          pageStates={pageStates}
                          type={"Staff Budget"}
                          EditData={pageStates?.EditData}
                          GetSiteBudgets={GetSiteBudget}
                          isLoading={pageStates.isLoading}
                          budgetLoading={budgetLoading}
                          setBudgetLoading={setBudgetLoading}
                        />
                      </div>
                    </Fade>
                  </TabPane>
                  <TabPane tabId={7}>
                    <Fade in={pageStates?.activeSubTab === 7} timeout={200}>
                      <div className="col-12">
                        {pageStates?.activeSubTab === 7 && (
                          <SupplyServiceBudget
                            EditData={pageStates?.EditData}
                            ThirdFormSubmit={ThirdFormSubmit}
                            pageStates={pageStates}
                            GetSiteBudgets={GetSiteBudget}
                            type={"General Expense Head"}
                            isLoading={pageStates.isLoading}
                            budgetLoading={budgetLoading}
                            setBudgetLoading={setBudgetLoading}
                          />
                        )}
                      </div>
                    </Fade>
                  </TabPane>
                </TabContent>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <RequestSelectorModal
        modal={requestModal}
        toggle={toggleRequestModal}
        handleCreateNew={handleCreateNew}
        handleEditExisting={handleEditExisting}
        handleDeleteExisting={handleDeleteExisting}
      />
    </>
  );
}
